module.exports = __webpack_public_path__ + "media/shadow-effect.6709ac15.mp4";